module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "fixed": _vm.fixedHeight
    }
  }, [(!_vm.hideTitle) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title", [_c('h3', [_vm._v("Title")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.hideDescription) ? _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._t("description", [_vm._v("\n      Description\n    ")])], 2) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5542a9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/DashboardSectionCard.vue
// module id = 3287
// module chunks = 3